export const REQUEST_URL = {
  //authen
  SIGN_IN: "/auth/login",
  LOG_OUT: "/auth/logout",

  //profile
  AUTH_PROFILE: "/auth/profile",
  CHANGE_PASSWORD: "/auth/password",
  AUTH_SESSIONS: "/auth/sessions",
  AUTH_SESSION_REVOKE: "/auth/sessions/{sessionId}/revoke",
  AUTH_SESSIONS_REVOKE_OTHERS: "/auth/sessions/revoke-others",
  AUDIT_LOGS: "/audit-logs",

  //employee
  EMPLOYEE: "/employee",
  EMPLOYEE_TEAM: "/employee/team",
  EMPLOYEE_TEAM_DETAIL: "/employee/team/_id",
  EMPLOYEE_TEAM_MEMBERS: "/employee/team/_id/members",
  EMPLOYEE_POSITION: "/employee/position",
  DELETE_EMPLOYEE: "/employee/_id",
  DELETE_EMPLOYEE_TEAM: "/employee/team/_id",
  DELETE_EMPLOYEE_POSITION: "/employee/position/_id",
  EMPLOYEE_AVATAR: "/employee/avatar",
  EMPLOYEE_PROFILE_PHOTO: "/employee/profile-photo",
  DELETE_EMPLOYEE_PROFILE_PHOTO: "/employee/profile-photo/{id}",
  EMPLOYEE_IMPORT: "/employee/import",
  EMPLOYEE_TRIGGER_DEVICE_SYNC: "/employee/trigger-device-sync",
  EMPLOYEE_PRESENCE: "/employee/presence",
  DEVICES: "/device",
  DEVICE_SYNC: "/device/{deviceId}/sync",
  DEVICE_CREDENTIALS: "/device/{deviceId}/credentials",
  DEVICE_RECOVERY_CODE: "/device/{deviceId}/recovery-code",
  DELETE_AVATAR_EMPLOYEE: "/employee/avatar/{id}",

  //timesheet
  REPORT_TIMEKEEPING: "/report/timekeeping",
  TIMEKEEPING_HISTORY: "/timekeeping/history",
  TIMEKEEPING_LIST: "/timekeeping/list",
  TIMEKEEPING: "/timekeeping",
  DELETE_TIMEKEEPING: "/timekeeping/{id}",
  TIMEKEEPING_ABSENCE: "/timekeeping/absence",

  //email
  EMAIL: "/email",
  DELETE_EMAIL: "/email/_id",
  ACTIVE_EMAIL: "/email/activate",

  // hr daily report
  HR_DAILY_REPORT_SUMMARY: "/hr/daily-report/summary",
  HR_DAILY_REPORT_PREVIEW: "/hr/daily-report/preview",
  HR_DAILY_REPORT_SEND: "/hr/daily-report/send",
  HR_DAILY_REPORT_LOGS: "/hr/daily-report/logs",

  // hr chat
  HR_CHAT: "/hr/chat",
  HR_CHAT_SESSIONS: "/hr/chat/sessions",
  HR_CHAT_SESSION: "/hr/chat/sessions/{id}",

  CUSTOMER_FEEDBACK_MAIL: "/customer/feedback-mail",
  CUSTOMER_FEEDBACK_LOGS: "/customer/feedback-logs",
} as const;
